module.exports = __webpack_public_path__ + "assets/images/cockpit/hover/btn_closedc-hover_ru.png";